import {
    Source,
} from 'one-model';

import {
    add,
    init,
    remove,
    select,
    unselect,
    SelectList,
} from 'one-state-core';

import {
    ADD,
    SET,
    RESET,
    REMOVE,
    SELECT,
    UNSELECT,
} from './types';

import {
    Actions,
} from './actions';

export const sortFunction = (a: Source, b: Source) => {
    const nameA = a?.firstname?.toLowerCase();
    const nameB = b?.firstname?.toLowerCase();
    return nameA > nameB ? 1 : -1;
}

function removeDuplicates(data: any) {
    if (data && data?.length > 0) {
        let jsonObject = data.map(JSON.stringify);
        let uniqueSet: any = new Set(jsonObject);
        let uniqueArray = Array.from(uniqueSet, JSON.parse);
        return uniqueArray;
    } else {
        return [];
    }
};

export const sources = (
    context: any,
    initial?: SelectList<Source>,
) => {
    const initValue = initial || {
        values: [],
    };

    return (
        state: SelectList<Source>,
        action: Actions,
    ) => {
        const {
            type,
            payload,
        } = action;

        let updated = state || initValue;
        let finalmerge:Source[]  = [];
        if(type === SET){
            //Getting existing values from the state
            let existing:Source[] = updated?.values;
            //Getting from the payload
            let setpayload = payload;
            //Merging existing with payload
            let concatmerge = existing?.concat(setpayload);
            //Remove Duplicates
            finalmerge = removeDuplicates(concatmerge);
            //Sorting the final merge
            finalmerge.sort(sortFunction);
        }

        switch (type) {
            case SET:
                updated = init<Source>(
                    updated,
                    finalmerge,
                );
                break;
                
            case RESET:
                updated = initValue;
                break;

            case ADD:
                updated = add<Source>(
                    updated,
                    payload as Source,
                );
                break;

            case REMOVE:
                updated = remove<Source>(
                    updated,
                    (source) => (
                        source.id === payload
                    ),
                );
                break;

            case SELECT:
                updated = select<Source>(
                    updated,
                    (source) => (
                        source.id === payload
                    ),
                );
                break;

            case UNSELECT:
                updated = unselect<Source>(
                    updated,
                );
                break;
        }
        return updated;
    }
};
